import React, {useState} from 'react'


export default function TextForm(props) {
    const handleUpClick = ()=>{
        //console.log("btn clicked");
        let newText = text.toUpperCase();
        setText(newText);
        //props.hh("csdc","danger");
        //alert("csd");
        props.hh("Converted to UPPER CASE!!", "success");
    }
    const handleLowClick = ()=>{
        let newText = text.toLowerCase();
        setText(newText);
        props.hh("Converted to lower case!!", "success");
    }
    const handleClrClick = () => {
        let newText = '';
        setText(newText);
        props.hh("Text has been cleared!!", "success");
    }
    const handleInvertClick = () => {
        let newText = '';
        let i = 0;
        while (i < text.length) {
            let n = text.charAt(i);
            if (n === n.toUpperCase()) {
                n = n.toLowerCase();
            } else {
                n = n.toUpperCase();
            }
            i += 1;
            newText += n;
        }
        setText(newText);
        props.hh("Text has been InVeRtEd!!", "success");
    }

    const handleExtraSpaces = ()=>{
        let newText = text.split(/[ ]+/);
        setText(newText.join(" "));
        props.hh("Extra Spaces are removed!!", "success");
    }

    const handleCopy=()=>{
        var text = document.getElementById("myBox");
        navigator.clipboard.writeText(text.value);
        props.hh("Copied!!", "success");;

    }

    const handleOnchange = (event)=>{
        //console.log("onc hnge");
        setText(event.target.value);
    }

    
    const [text, setText] = useState('Enter text here');
  return (
    <>
      <div className='container' style={{color: props.mode === 'dark'?'white':'black'}}>
         <h1>{props.heading}</h1>
          <div className="mb-3">
              <textarea className="form-control" value={text} onChange={handleOnchange} style={{color: props.mode === 'dark'?'white':'black', backgroundColor: props.mode === 'dark'?'#535963':'white'}} id="myBox" rows="8"></textarea>
          </div>
          <button className="btn btn-primary mx-2 my-2" onClick={handleUpClick}>Convert to Upper Case</button>
          <button className="btn btn-primary mx-2 my-2" onClick={handleLowClick}>Convert to Lower Case</button>
          <button className="btn btn-primary mx-2 my-2" onClick={handleInvertClick}>Invert Case</button>
          <button className="btn btn-primary mx-2 my-2" onClick={handleExtraSpaces}>Remove Extra Spaces</button>
          <button className="btn btn-secondary mx-2 my-2" onClick={handleCopy}>Copy Text</button>
          <button className="btn btn-danger mx-2 my-2" onClick={handleClrClick}>Clear</button>
      </div>
      <div className="container my-3" style={{color: props.mode === 'dark'?'white':'black'}}>
        <h1>Your text summary</h1>
        <p>{text.split(" ").filter((element)=>{return element.length!==0}).length} words & {text.length} characters</p>
        <p>{0.008 * text.split(" ").length} Minutes to Read</p>
        <h2>Preview</h2>
        <p>{text.length>0?text:"Write something to Preview"}</p>
      </div>

      </>
  )
}
